import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import { TransformUnix } from '../../../../../_config/functions/transform-unix';
import CustomCard from '../../../../../v2-components/Antd/Card';
import CustomPagination from '../../../../../v2-components/Antd/Pagination';
import CustomTabs from '../../../../../v2-components/Antd/Tabs';
import { notificationType } from '../../constants/notification-type.constant';
import { status } from '../../constants/status.constant';
import { typeDelivery } from '../../constants/type-delivery';
import { useState, useEffect, useMemo } from 'react';
import CustomCheckbox from '../../../../../v2-components/Antd/Checkbox';
import CustomSelect from '../../../../../v2-components/Antd/Select';
import CustomMenu from '../../../../../v2-components/Antd/Menu';
import CustomMenuItem from '../../../../../v2-components/Antd/MenuItem';
import { selectOptions, pharmacyOptions } from '../../constants/select-options.constant';
import { ENVIROMENT } from '../../../../../v2-config/constants/enviroments.constant';
import CustomDropdown from '../../../../../v2-components/Antd/Dropdown';
import { RightOutlined, ArrowDownOutlined, ArrowUpOutlined, MoreOutlined } from '@ant-design/icons';
import CustomButton from '../../../../../v2-components/Antd/Button';
import { getTimeAgo } from '../../../../../_config/utils/get-time-ago.handle';
import { GetLocalStorageValue } from '../../../../../_config/utils/get-local-storage-value.util';
import { Link } from 'react-router-dom';
import { checkNotificationType } from './handle/check-notification-type.handle';
import { navigationOptions } from './constants/navigation-options.constant';
import './style.scss';

export default function NotificationTable(props) {
	const {
		onPageChange,
		pagination,
		tabOptions,
		initialActiveTab,
		setSeen,
		onTabChange,
		onFilterChange,
		onOrderChange,
		orderBy,
		onMarkAsRead,
		isAdmin,
		onStatusChange,
	} = props;
	const [activeTabKey, setActiveTabKey] = useState(initialActiveTab);
	const [selectedNotifications, setSelectedNotifications] = useState({});
	const [filteredTabs, setFilteredTabs] = useState([]);
	const [selectedValue, setSelectedValue] = useState(null);
	const user = GetLocalStorageValue('userInfo');
	console.log('activeTabKey', activeTabKey);

	useEffect(() => {
		const filtered = tabOptions.map((tab) => ({
			...tab,
			data: tab.data?.filter((item) => !!item) || [],
		}));
		setFilteredTabs(filtered);
	}, [tabOptions]);

	const getActiveTabData = useMemo(() => {
		const activeTab = filteredTabs.find((tab) => tab.key === activeTabKey);
		return activeTab?.data || [];
	}, [filteredTabs, activeTabKey]);

	const isAllSelected = useMemo(() => {
		if (getActiveTabData.length === 0) return false;
		return getActiveTabData.every((item) => selectedNotifications[item._id]);
	}, [getActiveTabData, selectedNotifications]);

	const handleSelectAll = (checked) => {
		const newSelectedItems = { ...selectedNotifications };

		getActiveTabData.forEach((item) => {
			newSelectedItems[item._id] = checked;
		});

		setSelectedNotifications(newSelectedItems);
	};

	// Manejar selección individual de card
	const handleSelectItem = (itemId, checked) => {
		setSelectedNotifications({
			...selectedNotifications,
			[itemId]: checked,
		});
	};

	// Resetear selección cuando cambia la tab
	useEffect(() => {
		setSelectedNotifications({});
	}, [activeTabKey]);

	const handleTabClick = (key) => {
		setActiveTabKey(key);
		const tab = tabOptions.find((tab) => tab.key === key);
		if (tab) {
			console.log('tab', tab);
			setSeen(tab.seen);
			onTabChange();
			onStatusChange(tab.seen);
		}
	};

	const handleSelectChange = (value) => {
		setSelectedValue(value);
		onFilterChange('notificationType', value);
		console.log('Seleccionado:', value);
	};

	const handlePharmacyClick = (pharmacy) => {
		setSelectedValue(pharmacy);
		onFilterChange('pharmacy', pharmacy);
		console.log('Seleccionado:', pharmacy);
	};

	const handleMarkAsReadClick = () => {
		console.log('entro');
		const selectedIds = Object.keys(selectedNotifications).filter((id) => selectedNotifications[id]);
		if (selectedIds.length > 0) {
			console.log('estado notificacion', activeTabKey === 'read');
			onMarkAsRead(selectedIds, activeTabKey !== 'read');
			setSelectedNotifications({});
		}
	};

	const pharmacyMenu = (
		<CustomMenu>
			{pharmacyOptions.map((pharmacy) => (
				<CustomMenuItem key={pharmacy.value} onClick={() => handlePharmacyClick(pharmacy.value)}>
					{pharmacy.label}
				</CustomMenuItem>
			))}
		</CustomMenu>
	);

	const moreActionsMenu = (
		<CustomMenu>
			{activeTabKey === 'all' &&
				[
					{
						label: 'Marcar como leídas',
						seen: true,
					},
					{
						label: 'Marcar como no leídas',
						seen: false,
					},
				].map(({ label, seen }) => (
					<CustomMenuItem
						key={label}
						onClick={() => {
							const selectedIds = Object.keys(selectedNotifications).filter((id) => selectedNotifications[id]);
							if (selectedIds.length > 0) {
								onMarkAsRead(selectedIds, seen);
								setSelectedNotifications({});
							}
						}}
					>
						{label}
					</CustomMenuItem>
				))}
		</CustomMenu>
	);

	const handleOrderClick = () => {
		onOrderChange();
	};

	return (
		<>
			<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
				<span style={{ marginRight: '10px' }}>Filtrar por:</span>
				<CustomSelect
					options={selectOptions[ENVIROMENT.COUNTRY]}
					placeholder="Seleccione una opción"
					style={{ width: 200 }}
					value={selectedValue ?? undefined}
					onChange={handleSelectChange}
					dropdownRender={(menu) => (
						<div>
							{menu}
							{isAdmin && (
								<CustomDropdown overlay={pharmacyMenu} trigger={['hover']} placement="left">
									<div style={{ padding: '8px 16px', cursor: 'pointer' }}>
										Farmacias <RightOutlined />
									</div>
								</CustomDropdown>
							)}
						</div>
					)}
				></CustomSelect>
			</div>

			<CustomTabs onChange={handleTabClick} activeKey={activeTabKey || initialActiveTab}>
				{filteredTabs.map((tab) => (
					<CustomTabs key={tab.key} tab={tab.tab}>
						{/* <div className="select-all-container" style={{ padding: '10px', marginBottom: '10px', marginLeft: '15px' }}> */}
						<div
							className="select-all-container"
							style={{
								padding: '10px',
								marginBottom: '10px',
								marginLeft: '15px',
								display: 'flex',
								justifyContent: 'space-between',
							}}
						>
							{tab.data.length > 0 ? (
								<>
									<CustomCheckbox
										style={{ marginBottom: '8px' }}
										checked={isAllSelected}
										onChange={(e) => handleSelectAll(e.target.checked)}
									>
										Seleccionar todas
									</CustomCheckbox>
									<div style={{ display: 'flex', alignItems: 'center' }}>
										{activeTabKey === 'all' ? (
											<CustomDropdown overlay={moreActionsMenu} trigger={['click']}>
												<CustomButton type="text">
													<MoreOutlined />
												</CustomButton>
											</CustomDropdown>
										) : (
											<CustomButton type="text" onClick={handleMarkAsReadClick} style={{ marginRight: '10px' }}>
												{navigationOptions[activeTabKey]}
											</CustomButton>
										)}
										<CustomButton onClick={handleOrderClick} type="text">
											{orderBy === 'desc' ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
										</CustomButton>
									</div>
								</>
							) : null}
						</div>
						{tab.data.map((item) => (
							<CustomCard className={`notification-card ${!item?.seen ? 'not-seen-notification-card' : 'seen-notification-card'}`}>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<div className="individual-select" style={{ marginRight: '10px' }}>
										<CustomCheckbox
											h
											checked={!!selectedNotifications[item._id]}
											onChange={(e) => handleSelectItem(item._id, e.target.checked)}
										/>
									</div>
									<h4 className={'text-centered'}>{notificationType[item?.type]}{item?.type === 'new-quotation' || item?.type === 'new-preorder' ? item?.data?.shortCode : item?.type_id}</h4>
								</div>
								<Link
									to={checkNotificationType({
										notificationType: item?.type,
										isAdmin: user?.admin,
										pharmacy: item?.data?.pharmacy,
										type_id: item?.type_id,
										id: item?.data?.id
									})}
									onClick={() => {
										if (!item?.seen) {
											onMarkAsRead([item._id], true);
										}
									}}
									style={{ color: 'inherit', textDecoration: 'none' }}
								>
									<p className={'text-centered'} style={{ marginLeft: '28px' }}>
										Farmacia {item?.data?.pharmacy ==='fanich' ? 'La Botica Anich' : item?.data?.pharmacy}
									</p>
									<p className={'text-centered'} style={{ marginLeft: '28px' }}>
										Usuario {item?.email}
									</p>
									{item?.type === 'new-claim' && (
										<p className={'text-centered'} style={{ marginLeft: '28px' }}>
											Estado: {status[item?.data?.status]}
										</p>
									)}
									{item?.type === 'new-order' && (
										<p className={'text-centered'} style={{ marginLeft: '28px' }}>
											{typeDelivery[item?.data?.type_retirement]}
										</p>
									)}
									<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '30px' }}>
										<p className={'text-centered'} style={{ marginLeft: '28px' }}>
											{TransformUnix[Enviroment.COUNTRY].handleFormat(item?.created_at)}
										</p>
										<p>{getTimeAgo(item?.created_at)}</p>
									</div>
								</Link>
							</CustomCard>
						))}
					</CustomTabs>
				))}
			</CustomTabs>
			<CustomPagination
				current={pagination.currentPage}
				pageSize={pagination.pageSize}
				total={pagination.totalItems}
				showSizeChanger={false}
				onChange={(page) => onPageChange(page)}
			/>
		</>
	);
}
